export let Accounting = /*#__PURE__*/function (Accounting) {
  Accounting["QBO"] = "qbo";
  Accounting["Xero"] = "xero";
  return Accounting;
}({});
export let InvoiceIntegrationStatusDTO = /*#__PURE__*/function (InvoiceIntegrationStatusDTO) {
  InvoiceIntegrationStatusDTO["PendingSync"] = "pendingSync";
  InvoiceIntegrationStatusDTO["Synced"] = "synced";
  InvoiceIntegrationStatusDTO["SyncFailed"] = "syncFailed";
  InvoiceIntegrationStatusDTO["PaymentFailed"] = "paymentFailed";
  InvoiceIntegrationStatusDTO["Voided"] = "voided";
  InvoiceIntegrationStatusDTO["Paid"] = "paid";
  InvoiceIntegrationStatusDTO["Refunded"] = "refunded";
  InvoiceIntegrationStatusDTO["RefundFailed"] = "refundFailed";
  return InvoiceIntegrationStatusDTO;
}({});